import { Database, BarChart2, HardDrive, Download, Table, Activity } from 'lucide-react';
import TabHub from '@/components/shared/TabHub';
import DatabaseSummary from '@/components/admin/DatabaseSummary';
import TableInventory from '@/components/admin/TableInventory';
import DataWarehouseStatus from '@/components/data/DataWarehouseStatus';
import DataExportDownload from '@/components/data/DataExportDownload';
import ComingSoon from '@/components/shared/ComingSoon';

const PipelineMonitorView = () => (
  <ComingSoon
    title="Pipeline Monitor"
    description="Monitor data pipeline health, scheduler status, and cloud function execution across all 9 asset classes."
    icon={Activity}
    availableIn="Next Release"
    features={[
      "Cloud Function execution status and logs",
      "Data pipeline scheduling dashboard",
      "BigQuery ingestion metrics per asset class",
      "TwelveData API health monitoring",
      "Historical run performance analytics",
    ]}
  />
);

export default function DataInfrastructureHub() {
  return (
    <TabHub
      title="Data Infrastructure"
      subtitle="BigQuery tables, schema viewer, warehouse status, pipeline monitor, and data exports"
      icon={Database}
      accentColor="#06b6d4"
      defaultTab="summary"
      tabs={[
        { id: 'summary', label: 'DB Summary', icon: BarChart2, component: <DatabaseSummary theme="dark" /> },
        { id: 'inventory', label: 'Table Inventory', icon: Table, component: <TableInventory theme="dark" /> },
        { id: 'warehouse', label: 'Warehouse Status', icon: HardDrive, component: <DataWarehouseStatus theme="dark" /> },
        { id: 'export', label: 'Data Export', icon: Download, component: <DataExportDownload theme="dark" /> },
        { id: 'pipeline', label: 'Pipeline Monitor', icon: Activity, badge: 'SOON', component: <PipelineMonitorView /> },
      ]}
    />
  );
}
